var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalSupply(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 41,
    fill: "#00F3AB",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5 67C27.4167 67 16 55.5833 16 41.5C16 27.4167 27.4167 16 41.5 16C55.5833 16 67 27.4167 67 41.5C67 55.5833 55.5833 67 41.5 67ZM41.5 21.4647C30.4348 21.4647 21.4647 30.4348 21.4647 41.5C21.4647 52.5652 30.4348 61.5354 41.5 61.5354C52.5652 61.5354 61.5354 52.5652 61.5354 41.5C61.5354 30.4348 52.5652 21.4647 41.5 21.4647ZM37.6367 50.5159C39.7707 52.6495 43.2301 52.6495 45.3641 50.5159L50.5159 45.3641C52.6495 43.2301 52.6495 39.7707 50.5159 37.6367L45.3641 32.4849C43.2301 30.3514 39.7707 30.3514 37.6367 32.4849L32.4849 37.6367C30.3514 39.7707 30.3514 43.2301 32.4849 45.3641L37.6367 50.5159Z",
    fill: "#00F3AB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSupply);
export default __webpack_public_path__ + "static/media/totalSupply.294a1f976a360a2b40764f7f035a9293.svg";
export { ForwardRef as ReactComponent };